import { FieldError, FieldErrorsImpl, Merge } from 'react-hook-form';

type Props = {
	error: string | FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined;
	className?: string;
};

export default function MessageError({ error, className }: Props) {
	if (typeof error !== 'string') {
		return null;
	}

	return <span className={`text-xs text-red-500 flex justify-end mt-1 ${className}`}>{error}</span>;
}
